import React from 'react';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import ZipcodeService from '../../../services/zipcodeService';
import { getTranslations } from '../../../services/languageUtils';

class AddressSection extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            translations: {}
        };
    }

    loadTranslations = async () => {
        const translations = await getTranslations((localStorage.getItem('language') || 'pt'));
        this.setState({ translations });
    };

    componentDidMount() {
        this.loadTranslations();
    }

    searchZipcode = (e) => {
        let zipcode = e.target.value.replace(/\D/g, '');
        if (zipcode.length === 8) {
            ZipcodeService.searchZipcode(zipcode).then((res) => {
                if (res.data && !res.data.erro) {
                    this.props.onChange('street', res.data.logradouro || '');
                    this.props.onChange('neighborhood', res.data.bairro || '');
                    this.props.onChange('city', res.data.localidade || '');
                    this.props.onChange('state', res.data.uf || '');
                } else {
                    toast.error('CEP não encontrado');
                }
            }).catch((error) => {
                console.error('Erro ao buscar CEP:', error);
                toast.error('Erro ao buscar CEP');
            });
        }
    };

    maskZipcode = (value) => {
        let returnValue = value.replace(/\D/g, "");
        if (returnValue.length > 5) {
            returnValue = returnValue.replace(/^(\d{5})(\d{0,3})/, "$1-$2");
        }
        return returnValue;
    };

    handleChange = (fieldName, value) => {
        if (fieldName === 'postalCode') {
            const maskedValue = this.maskZipcode(value);
            this.props.onChange(fieldName, maskedValue);
            this.searchZipcode({ target: { value: maskedValue } });
        } else {
            this.props.onChange(fieldName, value);
        }
    };

    handleNext = () => {
        this.props.onNext();
    };

    handleBack = () => {
        this.props.onBack();
    };

    render() {
        const { data, errors, isLoading } = this.props;
        const { translations } = this.state;

        return (
            <div className="sideRightContent">
                <ToastContainer />
                <div className="textContentSteps">
                    <div className="h1">
                        <div className="h1Label">
                            <img src={require("../../../assets/imgs/ico-higher-titulo.svg").default} alt="Logo Higher" className="titleImage"/>
                        </div>
                        <div className="h1LabelMobile">
                            2
                        </div>
                        Endereço da Empresa
                    </div>
                    <br/>

                    <p className="h5">Informe o endereço completo da sua empresa</p>
                    <div className="contentInputText" style={{maxWidth: "150px"}}>
                        <p className="label">CEP</p>
                        <input 
                            inputMode="numeric"
                            className={"input " + (errors.postalCode ? "inputDanger" : "")} 
                            value={data.postalCode} 
                            type="text" 
                            onChange={(e) => this.handleChange('postalCode', e.target.value)}
                            placeholder="00000-000"
                            maxLength="9"
                        />
                        {errors.postalCode && <span style={{color: '#FF460C', fontSize: '12px', display: 'block', marginTop: '5px'}}>{errors.postalCode}</span>}
                    </div>

                    <div className="contentInputText">
                        <p className="label">Rua/Logradouro</p>
                        <input 
                            className={"input " + (errors.street ? "inputDanger" : "")} 
                            value={data.street} 
                            type="text" 
                            onChange={(e) => this.handleChange('street', e.target.value)}
                            placeholder="Nome da rua"
                        />
                        {errors.street && <span style={{color: '#FF460C', fontSize: '12px', display: 'block', marginTop: '5px'}}>{errors.street}</span>}
                    </div>

                    <div className="contentInputText" style={{maxWidth: "100px"}}>
                        <p className="label">Número</p>
                        <input 
                            className={"input " + (errors.number ? "inputDanger" : "")} 
                            value={data.number} 
                            type="text" 
                            onChange={(e) => this.handleChange('number', e.target.value)}
                            placeholder="123"
                        />
                        {errors.number && <span style={{color: '#FF460C', fontSize: '12px', display: 'block', marginTop: '5px'}}>{errors.number}</span>}
                    </div>

                    <div className="contentInputText">
                        <p className="label">Bairro</p>
                        <input 
                            className={"input " + (errors.neighborhood ? "inputDanger" : "")} 
                            value={data.neighborhood} 
                            type="text" 
                            onChange={(e) => this.handleChange('neighborhood', e.target.value)}
                            placeholder="Nome do bairro"
                        />
                        {errors.neighborhood && <span style={{color: '#FF460C', fontSize: '12px', display: 'block', marginTop: '5px'}}>{errors.neighborhood}</span>}
                    </div>

                    <div className="contentInputText">
                        <p className="label">Cidade</p>
                        <input 
                            className={"input " + (errors.city ? "inputDanger" : "")} 
                            value={data.city} 
                            type="text" 
                            onChange={(e) => this.handleChange('city', e.target.value)}
                            placeholder="Nome da cidade"
                        />
                        {errors.city && <span style={{color: '#FF460C', fontSize: '12px', display: 'block', marginTop: '5px'}}>{errors.city}</span>}
                    </div>

                    <div className="contentInputs contentInputSmall" style={{minWidth: "100px", margin: "0px"}}>
                        <p className="label">Estado</p>
                        <select 
                            className={"select " + (errors.state ? "inputDanger" : "")} 
                            value={data.state} 
                            onChange={(e) => this.handleChange('state', e.target.value)}
                        >
                            <option value="">UF</option>
                            <option value="AC">AC</option>
                            <option value="AL">AL</option>
                            <option value="AP">AP</option>
                            <option value="AM">AM</option>
                            <option value="BA">BA</option>
                            <option value="CE">CE</option>
                            <option value="DF">DF</option>
                            <option value="ES">ES</option>
                            <option value="GO">GO</option>
                            <option value="MA">MA</option>
                            <option value="MT">MT</option>
                            <option value="MS">MS</option>
                            <option value="MG">MG</option>
                            <option value="PA">PA</option>
                            <option value="PB">PB</option>
                            <option value="PR">PR</option>
                            <option value="PE">PE</option>
                            <option value="PI">PI</option>
                            <option value="RJ">RJ</option>
                            <option value="RN">RN</option>
                            <option value="RS">RS</option>
                            <option value="RO">RO</option>
                            <option value="RR">RR</option>
                            <option value="SC">SC</option>
                            <option value="SP">SP</option>
                            <option value="SE">SE</option>
                            <option value="TO">TO</option>
                        </select>
                        {errors.state && <span style={{color: '#FF460C', fontSize: '12px', display: 'block', marginTop: '5px'}}>{errors.state}</span>}
                    </div>

                    <div className="lineBtnSaveAndContinue">
                        <div 
                            className="btnSaveAndContinue" 
                            onClick={!isLoading ? this.handleBack : undefined}
                            style={{
                                opacity: isLoading ? 0.6 : 1,
                                cursor: isLoading ? 'not-allowed' : 'pointer',
                                width: '150px',
                                backgroundColor: '#6c757d',
                                borderColor: '#6c757d'
                            }}
                        >
                            {isLoading ? 'Carregando...' : 'Voltar'}
                        </div>
                        <div 
                            className="btnSaveAndContinue" 
                            onClick={!isLoading ? this.handleNext : undefined}
                            style={{
                                opacity: isLoading ? 0.6 : 1,
                                cursor: isLoading ? 'not-allowed' : 'pointer',
                                width: '320px'
                            }}
                        >
                            {isLoading ? 'Carregando...' : 'Continuar para Documentos'}
                            {!isLoading && (
                                <div className="arrow">
                                    <img 
                                        src={require("../../../assets/imgs/seta-right-branca.svg").default} 
                                        alt="Próximo" 
                                        className="arrowNext"
                                    />
                                </div>
                            )}
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default AddressSection;